<template>
    <el-dialog
            class="leader-dialog"
            title="查看"
            width="1200px"
            :visible.sync="dialogStatus"
            @close="closeDiaCb"
            :close-on-click-modal="false"
            :append-to-body="true"
            destroy-on-close="true"
        >
        <div class="nbq_instant_module" :style="{height: true ? '25rem' : '18rem' }">
            <div class="tab_cont">
                <el-radio-group v-model="tabVal" @change="tabChange" class="leader-radio">
                    <el-radio-button
                        v-for="val in radioButtons"
                        :key="val.point_class_column_kind_id"
                        :label="val.point_class_column_kind_id"
                    >{{ val.kind_name }}</el-radio-button>
                </el-radio-group>
                <div class="btn_cont">
                    <el-button
                        icon="el-icon-menu"
                        class="leader-common-button"
                        @click="tableSwitch = true"
                    >图表</el-button>
                    <el-button
                        icon="el-icon-date"
                        class="leader-common-button"
                        @click="tableSwitch = false"
                    >数据</el-button>
                </div>
            </div>
            <div class="chart_content" style="height:calc(100% - 4rem)">
                <div
                    class="echart-container"
                    v-if="this.tableSwitch"
                    v-loading="loadingInstantChart"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <v-chart :auto-resize="true" :options="lineRight1" ref="lineRight1" />
                </div>
                <div class="table-container" v-if="!this.tableSwitch">
                    <el-scrollbar style="height: 100%">
                        <el-table
                            :data="tableData"
                            border
                            v-loading="TloadingInstantChart"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                            class="leader-style-table"
                            style="width: auto;"
                        >
                            <el-table-column
                                v-for="val in tableHeader"
                                :key="val.column_val"
                                :prop="val.column_val"
                                :label="val.column_key"
                                align="center"
                            ></el-table-column>
                        </el-table>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import "echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import dayjs from "dayjs";
import { getDataAll } from "@/http/http-60.js";
import * as api from "@/http/api.js"
export default {
    props: {
        curPoint: {
            type: Object
        },
        searchForm: {
            type: Object,
            required: true,
            default: () => {
                return {
                    from_date: "from_date",
                    to_date: "to_date"
                };
            }
        },
        dialogStatus: {
            Boolean
        }
    },
    data() {
        return {
            loadingInstantChart:false,
            TloadingInstantChart: false,
            tableSwitch: true,
            unit: '',
            tableData: [],
            x_list: [],
            series: [],
            legend: [],
            tableHeader: [],
            radioButtons: [],
            tabVal: '',
        }
    },
    methods: {
        closeDiaCb() {
            this.$emit("update:dialogStatus", false);
        },
        async tabChange(point_class_column_kind_id) {
            this.tabVal = point_class_column_kind_id;
            await this.getRealTimeData1(point_class_column_kind_id);
        },
        async getPointColumnKinds(point_id) {
            await api.getPointColumnKinds({ point_id: point_id }).then(res => {
                if (res && res.error_code === "0") {
                    this.radioButtons = res.bus_json.filter(item => item.point_class_column_kind_id != '1689909850420715530' && item.point_class_column_kind_id != '1689909850420715531');
                    this.tabVal = this.radioButtons && this.radioButtons.length && this.radioButtons[0].point_class_column_kind_id;
                    this.getRealTimeData1(this.tabVal);
                }
            });
        }, 
        async getRealTimeData1(point_class_column_kind_id) {
            if(!point_class_column_kind_id) return;
            this.loadingInstantChart = true;
            this.TloadingInstantChart = true;
            await api.getRealTimeData({
                from_date: this.searchForm.from_date,
                to_date: this.searchForm.to_date,
                point_id: this.curPoint.point_id,
                point_class_column_kind_id: point_class_column_kind_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.x_list;
                    // 数据
                    this.series = [];
                    // 图例
                    this.legend = [];

                    // 表格头部
                    this.tableHeader = [
                        {
                            column_key: "采集时间",
                            column_val: "time"
                        }
                    ];
                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.column_desc,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.unit = item.column_unit;
                        this.legend.push(item.column_desc);
                        this.series.push(everyData);
                        // 表格
                        let header_obj = {
                            column_key: item.column_desc,
                            column_val: item.column_name
                        };
                        this.tableHeader.push(header_obj);
                    });

                    //  表格
                    this.tableData = [];
                    this.x_list.forEach((V, index) => {
                        let data_obj = {
                            time: V
                        };
                        res.bus_json.y_list.forEach(T => {
                            data_obj[T.column_name] = T.dataList[index];
                        });
                        this.tableData.push(data_obj);
                    });
                    // setTimeout(() => {
                    // loading.close();
                    this.loadingInstantChart = false;
                    this.TloadingInstantChart = false;
                    // }, 5000)

                }
            });
        },
    },
    watch: {
        curPoint: {
            async handler(newValue) {
                if(!newValue) return;
                //this.curPoint = newValue;
                await this.getPointColumnKinds(this.curPoint.point_id);
            },
            deep: true,
            immediate: true
        },
        dialogStatus: {
            async handler(newValue) {
                if(newValue) {
                    this.getRealTimeData1(this.tabVal);
                }
            },
            deep: true,
            immediate: true
        },
    },
    computed: {
        lineRight1() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.legend,
                    itemHeight: 14,
                    textStyle: {
                        fontSize: 10,
                        lineHeight: 12,
                        color: "#fff"
                    },
                    type: 'scroll',
                    pageIconColor: '#aaa',
                    pageIconInactiveColor: '#666666',
                    pageTextStyle: {
                        color: '#fff',
                    },
                    textStyle: {
                        color: '#fff',
                        fontSize: 10,
                    }
                },
                calculable: true,
                xAxis: {
                    data: this.x_list,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                       // rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: `${this.unit}`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff' //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' //颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "6%",
                    right: "6%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                series: this.series,
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        },
    },
}
</script>

<style lang="scss">
.nbq_instant_module {
    width: 100%;
   // height: 18rem;
    box-sizing: content-box;
    .tab_cont {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .btn_cont {
            text-align: right;width: 20rem;
        }
    }
    .chart_content {
        width: 100%;
        height: 100%;
        margin-top: 0.5rem;
        .echart-container {
            width: 100%;
            height: 100%;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
        .table-container {
            width: 100%;
            height: 100%;
            table {
                width: auto !important;
            }
        }
    }
}
</style>